import React, { useEffect, useRef, useState, useContext, createContext, createElement } from 'react'
import axios from 'axios'
//Simple XML to JavaScript object converter.
import toast, { Toaster } from 'react-hot-toast'
// Formatting the date time format of the script
import moment from 'moment'
import './TranscriptEditor.css'
import { useHistory, Link, useParams } from 'react-router-dom'
import { DropDown, HorizontalLayout } from '../Components'
import { saveAs } from 'file-saver'
import TextareaAutosize from 'react-textarea-autosize';
import { myFunction,publishClick } from '../Recording/index.js';
import { compact, toPlainObject } from 'lodash';
import { generateSRT } from 'subtitle-generator';
import { TextGrid } from 'textgrid'
import { toggleListItemExpand } from 'react-admin'

const ReactDomServer = require('react-dom/server');
const convert = require('xml-js');
var ed = require('edit-distance');
var parseSRT = require('parse-srt');
var textgrid = require('textgrid');

var sentenceIdChanged = [];

const Sentence = ({ index,handleChanges,sentence,sentenceHandler, fileFormat, fileData }) => {

    const [sent,setSent] = useState(sentence);

    // const sentenceHandlerTwo=()=>{
    //     sentenceHandler();
    // }

    const handleInput = (e) => {
        if (!sentenceIdChanged.includes(index)){sentenceIdChanged.push(index);}
        handleChanges(e.target.value);
        setSent(e.target.value);
        sentenceHandler();
    }

    return (
        fileFormat.substring(fileFormat.indexOf('.')+1) == "xml" ? 
        (
            <TextareaAutosize
                rows="2" 
                style={{overflow : 'hidden', width : '100%', border : 'none'}} 
                value={sent} 
                onChange={handleInput.bind(this)}
            >
            </TextareaAutosize>
        ) :
        (
            < TextareaAutosize 
                rows="2" 
                style={{overflow : 'hidden', width : '100%', border : 'none'}} 
                value={sent} 
                onChange={e => {
                    setSent(e.target.value);
                    sentenceHandler();
                    if (!sentenceIdChanged.includes(index)){sentenceIdChanged.push(index)};
                    fileData[index].text = e.target.value;
                }}>
            </TextareaAutosize>
        )
    )
}

const getTranscriptSentence = (words) => {
    var sentences = words.map(s => s._);
    return sentences.join(' ');
}

const TranscriptButton = ({ id }) => {
    const history = useHistory()
    const role = localStorage.getItem('role')
    const TRANSCRIPT_OPTIONS = {
        CHANGE: 'Change Transcript',
        CLEAR: 'Clear Transcript',
    }

    const handleClick = (val) => {}

    if (role === 'admin' || role === 'uploader') {
        return (
            <>
                <DropDown
                    selected={'Transcript'}
                    list={[TRANSCRIPT_OPTIONS.CHANGE, TRANSCRIPT_OPTIONS.CLEAR]}
                    setSelected={handleClick}
                />
            </>
        )
    } else return null
}

const TranscriptEditor = ({
    transcriptData,
    jumpTo,
    fileName,
    handleWordChange,
    transcriptXMLPath,
    state,
    setState,
}) => {

    const [editedTranscriptState, setBtnState] = useState(false);
    const [originalFullScript, setFullScript] = useState(null);
    const [originalScriptWordsOnly, setScript] = useState(null);
    const [defaultScript, setChangeURL] = useState(myFunction());

    function getOriginalTranscript(){
        // for xml
        if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "xml"){
            axios.get(`${process.env.REACT_APP_STUDIO_URL}/static/transcripts/${fileName}`)
            .then((response) => {
                // original script converted to json
                const json = JSON.parse(convert.xml2json(response.data, { compact: true, spaces: 2 }));
                setFullScript(json);
    
                // original script - words only
                let originalScriptWordsOnly = {}
                let parser = new DOMParser()
                let html = parser.parseFromString(response.data,"text/html") // html document
                for (let i = 0; i < html.getElementsByTagName("speechsegment").length; i++){
                    originalScriptWordsOnly[i] = html.getElementsByTagName("speechsegment")[i].textContent.replace(/(\r\n|\n|\r|\t|\s)+/g," ").trim().split(' ');
                }
                setScript(originalScriptWordsOnly)
            }).catch((err) => console.log(err))
        }

        else if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "TextGrid"){
            axios.get(`${process.env.REACT_APP_STUDIO_URL}/static/transcripts/${fileName}`)
            .then(response => {
                console.log(response.data)
                const json = TextGrid.textgridToJSON(response.data)
                setFullScript(json);
            })
        }
    }

    useEffect(() => {
        getOriginalTranscript();
    },[])

    const sentenceHandler = () => {
        setBtnState(true);
    }

    const { id } = useParams();
    
    // Download function
    const handleDownload = () => {
        transcriptXMLPath = defaultScript ? `static/transcripts/${fileName}` : `static/transcripts/draft/${fileName}`;
        saveAs(
            `${process.env.REACT_APP_STUDIO_URL}/${transcriptXMLPath}`,
            fileName
        )
    }

    // Save Draft function
    const handleSave = () => {

        if (window.confirm('Are you sure you want to save?\n\nPlease ensure that all words are separated by a space or the results after download will not be correct.')){  
            setChangeURL(false);

            // Define cost functions.
            var insert, remove, update;
            insert = remove = function(node) { return 1; };
            update = function(stringA, stringB) { return stringA !== stringB ? 1 : 0; };

            // Find out which sentence id and word id has been inserted, removed, or updated
            var changedScriptMap = {}

            if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "xml"){
                for (let i=0; i< sentenceIdChanged.length; i++){
                    // calculate edit distance
                    let newScript = transcriptData.AudioDoc.SegmentList[0].SpeechSegment[sentenceIdChanged[i]].Word[0]._.split(/\s+/);
                    let lev = ed.levenshtein(originalScriptWordsOnly[sentenceIdChanged[i]], newScript, insert, remove, update);
                    changedScriptMap[sentenceIdChanged[i]] = []
                    let arrLen = lev.pairs().length;
                    lev.pairs().reverse();
                    for (let j = 0; j < arrLen; j++){
                        if (lev.pairs()[j][0] != lev.pairs()[j][1]){
                            if (lev.pairs()[j][0] != null && lev.pairs()[j][1] == null){
                                changedScriptMap[sentenceIdChanged[i]].push({[j]:'deleted by '})
                            }
                            else if (lev.pairs()[j][0] == null && lev.pairs()[j][1] != null){
                                changedScriptMap[sentenceIdChanged[i]].push({[j]:'inserted by ' + lev.pairs()[j][1]})
                            }
                            else{
                                changedScriptMap[sentenceIdChanged[i]].push({[j]:'replaced by ' + lev.pairs()[j][1]})
                            }
                        }
                    }
                }

                // Change transcript accordingly
                for (var i in changedScriptMap){
                    let deletedWords = 0;
                    for (let j = 0; j < changedScriptMap[i].length; j++){
                        for (var k in changedScriptMap[i][j]){
                            k = parseInt(k);
                            let operation = changedScriptMap[i][j][k].split(' ').slice(0)[0].toString();
                            let newWord = changedScriptMap[i][j][k].split(' ').slice(2).toString();
                            if (operation == "replaced"){
                                originalFullScript.AudioDoc.SegmentList.SpeechSegment[i].Word[k-deletedWords]._text = newWord;
                            }
                            else if (operation == "deleted"){
                                originalFullScript.AudioDoc.SegmentList.SpeechSegment[i].Word.splice(k-deletedWords, 1);
                                deletedWords++;
                            }
                            else {
                                var newChange;
                                k == 0 ? newChange = Object.assign({},originalFullScript.AudioDoc.SegmentList.SpeechSegment[i].Word[k-deletedWords]) : 
                                    newChange = Object.assign({},originalFullScript.AudioDoc.SegmentList.SpeechSegment[i].Word[k-deletedWords-1]);
                                newChange._text = newWord;
                                originalFullScript.AudioDoc.SegmentList.SpeechSegment[i].Word.splice(k-deletedWords,0,newChange);
                            }
                        }
                    }
                }
                var editedTranscript = convert.json2xml(originalFullScript, { compact: true, spaces: 2 });
            }

            else if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "srt"){
                function secondsToTime(secs)
                {
                    var hours = Math.floor(secs / (60 * 60)).toString();

                    var divisor_for_minutes = secs % (60 * 60);
                    var minutes = Math.floor(divisor_for_minutes / 60).toString();

                    var divisor_for_seconds = divisor_for_minutes % 60;
                    var seconds = divisor_for_seconds.toFixed(3);

                    hours = hours.length == 1 ? "0" + hours : hours;
                    minutes = minutes.length == 1 ? "0" + minutes : minutes

                    var secondsFront = seconds.split('.')[0].length == 1 ? "0" + seconds.split('.')[0].toString() : seconds.split('.')[0].toString();
                    seconds = secondsFront + "," + seconds.split('.')[1];

                    return hours + ":" + minutes + ":" + seconds
                }

                const data = []

                for (let i=0; i<transcriptData.length; i++){
                    data.push({start: secondsToTime(transcriptData[i].start), end: secondsToTime(transcriptData[i].end), content: transcriptData[i].text})
                }

                var editedTranscript = generateSRT(data, 'timestamp');
            }

            else if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "TextGrid"){
                for (let i=0; i < sentenceIdChanged.length; i++){
                    var itemIndex = transcriptData[sentenceIdChanged[i]].itemIndex;
                    var intervalIndex = transcriptData[sentenceIdChanged[i]].intervalIndex;
                    var newText = transcriptData[sentenceIdChanged[i]].text;
                    originalFullScript.items[itemIndex].intervals[intervalIndex].text = newText;
                } 
                var editedTranscript = jsonToTextGrid(originalFullScript);
                console.log(editedTranscript)
            }

            else{
                var editedTranscript = jsonToSTM(transcriptData);
            }

            axios.put(
                `${process.env.REACT_APP_STUDIO_URL}/upload/transcript`,
                {fileName, data: editedTranscript, isDraft : true}
            ).then((response) => {
                toast.success('Transcript saved in draft successfully');
                setBtnState(false);
                sentenceIdChanged = [];
                changedScriptMap = {};
            }).
            catch (err => toast.error(err.message))
        }       
    }

    function jsonToTextGrid(script){

        var strToReturn = "";

        var fileHeaders = "File type = \"" + script.File_type + "\"" + "\nObject class = \"TextGrid\"" + 
            "\n\nxmin = 0" + "\nxmax = " + script.xmax + "\ntiers? <exist>" + "\nsize = " + script.size;
        var items = "\nitem []:";
        for (let i=0; i < script.items.length; i++){
            items += `\n    item [${i+1}]` + `\n        class = "${script.items[i].class}"` + `\n        name = "${script.items[i].name}"`
                + `\n        xmin = ${script.items[i].xmin}` + `\n        xmax = ${script.items[i].xmax}` + `\n        intervals: size = ${script.items[i].intervals_size}`;
                for (let j=0; j < script.items[i].intervals.length; j++){
                    items += `\n        intervals [${j+1}]:` + 
                        `\n            xmin = ${script.items[i].intervals[j].xmin}` + 
                        `\n            xmax = ${script.items[i].intervals[j].xmax}` + 
                        `\n            text = "${script.items[i].intervals[j].text}"`;
                }
        }
        strToReturn += fileHeaders + items;
        return strToReturn;

    }

    function jsonToSTM(script){

        var strToReturn = "";
        
        for (let i=0; i < script.length; i++){
            if (i==0){
                console.log(script[i].fileName)
                strToReturn += `${script[i].fileName} ${script[i].a} ${script[i].speaker} ${script[i].start} ${script[i].end} ${script[i].gender} ${script[i].text}`;
            }
            else{
                strToReturn += `\n${script[i].fileName} ${script[i].a} ${script[i].speaker} ${script[i].start} ${script[i].end} ${script[i].gender} ${script[i].text}`;
            }
        }

        return strToReturn;
    }

    return (
        // transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "xml" ?
            <div>
                <HorizontalLayout className="align-items-center">
                    <TranscriptButton id={id} />

                    <button
                        onClick={handleDownload}
                        className="btn btn-warning text-light mx-2"
                    >
                        Download
                    </button>
                    <button id = 'saveButton'
                        onClick={editedTranscriptState ? handleSave : () => {window.alert('Please edit transcript before saving.');}}
                        className={editedTranscriptState ? "btn btn-success" : "btn btn-secondary"}
                    >
                        Save
                    </button>
                    <div className="ml-auto">
                        <Link className="ml-auto" to={`/transcriptStudio/${id}`}>
                            Go to Magor Transcript Studio
                        </Link>
                    </div>
                </HorizontalLayout>
                <div className="transcript-editor">
                    {transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "xml" ? 
                        /* xml format */
                        (transcriptData &&
                            transcriptData.AudioDoc.SegmentList.map((sl, slIndex) =>
                                sl.SpeechSegment
                                .sort((a, b) => a.$.stime * 1000 > b.$.stime * 1000 ? 1 : -1)
                                .map((ss, ssIndex) => (
                                    <div className="speechSegment" key={ss.$.stime.toString()}>
                                        <label onClick={() => jumpTo(ss.$.stime * 1000)}>
                                            {moment
                                                .utc(ss.$.stime * 1000)
                                                .format('HH:mm:ss')}{' '}
                                        </label>
                                        <p>
                                            {/* <Word
                                                index = {ssIndex}
                                                words = {ss}
                                                handleChanges={(value) => handleWordChange(slIndex,ssIndex,value)}
                                                sentenceHandler = {sentenceHandler}
                                            /> */}
                                            <Sentence
                                                index={ssIndex} 
                                                handleChanges={(value) => handleWordChange(slIndex,ssIndex,value,transcriptXMLPath)}
                                                sentence={getTranscriptSentence(ss.Word)} 
                                                sentenceHandler = {sentenceHandler}
                                                fileFormat = {transcriptXMLPath}
                                            />
                                        </p>

                                    </div>
                                ))
                            ) 
                        ) : transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "srt" ? 
                        /* srt format */
                        (
                        transcriptData && 
                            transcriptData?.map((data,index) => 
                                <div className="speechSegment" key={data.start.toString()}>
                                    <label onClick={() => jumpTo(data.start * 1000)}>
                                        {moment
                                            .utc(data.start * 1000)
                                            .format('HH:mm:ss')}{' '}
                                    </label>
                                    <p>
                                        <Sentence
                                            index={index} 
                                            handleChanges={(value) => handleWordChange(0,index,value,transcriptXMLPath)}
                                            sentence={data.text} 
                                            sentenceHandler = {sentenceHandler}
                                            fileFormat = {transcriptXMLPath}
                                            fileData = {transcriptData}
                                        />
                                    </p>
                                </div>
                            )
                        ) : transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "TextGrid" ?
                        /* TextGrid format */
                        (
                        transcriptData && 
                            transcriptData?.map((data,index) =>
                                <div className="speechSegment" key={data.xmin.toString()}>
                                    <label onClick={() => jumpTo(data.xmin * 1000)}>
                                        {moment
                                            .utc(data.xmin * 1000)
                                            .format('HH:mm:ss')}{' '}
                                    </label>
                                    <p>
                                        <Sentence
                                            index={index} 
                                            handleChanges={(value) => handleWordChange(data.itemIndex,data.intervalIndex,value,transcriptXMLPath)}
                                            sentence={data.text} 
                                            sentenceHandler = {sentenceHandler}
                                            fileFormat = {transcriptXMLPath}
                                            fileData = {transcriptData}
                                        />
                                    </p>
                                </div>
                            )
                        ) : transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "stm" ?
                        /* stm format */
                        (
                        transcriptData && 
                            transcriptData.map((data,index) =>
                                <div className="speechSegment" key={data.start.toString()}>
                                    <label onClick={() => jumpTo(data.start * 1000)}>
                                        {moment
                                            .utc(data.start * 1000)
                                            .format('HH:mm:ss')}{' '}
                                    </label>
                                    <p>
                                        <Sentence
                                            index={index} 
                                            handleChanges={(value) => handleWordChange(0,index,value,transcriptXMLPath)}
                                            sentence={data.text} 
                                            sentenceHandler = {sentenceHandler}
                                            fileFormat = {transcriptXMLPath}
                                            fileData = {transcriptData}
                                        />
                                    </p>
                                </div>
                            )
                        ) :
                        (
                            <p>Text</p>
                        )
                    }
                </div>

                <Toaster
                    position="bottom-right"
                    reverseOrder
                    toastOptions={{
                        style: {
                            borderRadius: '10px',
                            background: '#333',
                            color: '#fff',
                        },
                    }}
                />
            </div>
    )
}

export default TranscriptEditor